import { useContext } from "react";
import { useNotifications } from "sprint-common-web";

import { CreateIntegratorFormInputs } from "./CreateIntegratorForm";
import { useAdminIntegratorApi } from "../../../api/useAdminIntegratorApi";
import { IntegratorContext } from "../../../context/IntegratorContext";

export const useCreateIntegratorForm = () => {
    const { createIntegrator: create } = useAdminIntegratorApi();
    const { addIntegratorItem } = useContext(IntegratorContext);
    const { success, error } = useNotifications();
    const createIntegrator = async (inputs: CreateIntegratorFormInputs) => {
        const name = inputs.name;

        const response = await create({
            name
        });

        addIntegratorItem({
            id: response.entityId,
            name,
            updatedDate: new Date().toISOString(),
            isModified: true
        });

        if (response.entityId) success("Integrator created succesfully");
        else error("Integrator creation failed");
    };

    return {
        createIntegrator
    };
};
